"use strict";
// @ts-ignore
try {
    self['workbox:navigation-preload:7.2.0'] && _();
}
catch (e) { }
